import { configureStore } from "@reduxjs/toolkit";

import OnlineStatusReducer from "./slices/onlineStatusSlice";
const store = configureStore({
  reducer: {
    OnlineStatus: OnlineStatusReducer,
  },
});

export default store;
